import { render, staticRenderFns } from "./shareVehicle.vue?vue&type=template&id=fb874f28&"
import script from "./shareVehicle.vue?vue&type=script&lang=js&"
export * from "./shareVehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports